var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddItem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 2.74984V1.9165H8.33333V2.74984H7.5V3.58317H8.33333V4.4165H9.16667V3.58317H10V2.74984H9.16667Z",
    fill: "#700540"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 3.99984C4.25417 3.99984 5 3.254 5 2.33317C5 1.41234 4.25417 0.666504 3.33334 0.666504C2.4125 0.666504 1.66667 1.41234 1.66667 2.33317C1.66667 3.254 2.4125 3.99984 3.33334 3.99984Z",
    fill: "#700540"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 4.4165C2.22083 4.4165 0 4.97484 0 6.08317V7.33317H6.66667V6.08317C6.66667 4.97484 4.44583 4.4165 3.33333 4.4165Z",
    fill: "#700540"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21249 0.6875C5.59583 1.12917 5.83333 1.70417 5.83333 2.33333C5.83333 2.9625 5.59583 3.5375 5.21249 3.97917C6.02916 3.875 6.66666 3.18333 6.66666 2.33333C6.66666 1.48333 6.02916 0.791667 5.21249 0.6875Z",
    fill: "#700540"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8875 4.76221C7.25833 5.10804 7.5 5.54137 7.5 6.08304V7.33304H8.33333V6.08304C8.33333 5.47887 7.67083 5.03721 6.8875 4.76221Z",
    fill: "#700540"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItem);
export default __webpack_public_path__ + "static/media/add-item.26461f9fbe40670563a6ea165a29fc39.svg";
export { ForwardRef as ReactComponent };